import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DlpReportService } from 'src/app/_services/dlpReport.service';

@Component({
  selector: 'popup-filtros-descarga',
  templateUrl: './popup-filtros-descarga.component.html',
})
export class PopupFiltrosDescargaComponent implements OnInit {
  filters: string;
  parsedFilters: { labelKey: string; values: string[] }[] = [];

  private readonly keyLabels: { [key: string]: string } = {
    mail: 'record.download.filtersModal.user',
    user: 'record.download.filtersModal.user',
    action: 'record.download.filtersModal.action',
    department: 'record.download.filtersModal.department',
    tag: 'record.download.filtersModal.label',
    dateBegin: 'record.download.filtersModal.dateBegin',
    dateEnd: 'record.download.filtersModal.dateEnd',
    policy: 'record.download.filtersModal.policy',
    type: 'record.download.filtersModal.type',
    priority: 'record.download.filtersModal.priority',
    externalDelivery: 'record.download.filtersModal.externalDelivery',
    infoLeak: 'record.download.filtersModal.informationLeakEvents',
    sensitiveCount: 'record.download.filtersModal.sensitiveCount',
    fileName: 'record.download.filtersModal.fileName',
    location: 'record.download.filtersModal.department',
    sensibleData: 'record.download.filtersModal.sensitiveData',
  };

  private readonly excludedKeys = ['sort', 'order', 'pg', 'pageSize', 'skipCount', 'culture', 'isDemo', 'onlyWithLabels'];

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private dlpReportService: DlpReportService,
  ) {}

  ngOnInit() {
    const parsed = this.tryParse();
    if (!parsed) return;

    const hasPolicy = parsed['policy'] && parsed['policy'] !== '';
    if (hasPolicy) {
      this.dlpReportService.getPolicies().subscribe({
        next: (res) => this.buildFilters(parsed, res?.body ?? []),
        error: () => this.buildFilters(parsed, []),
      });
    } else {
      this.buildFilters(parsed, []);
    }
  }

  private tryParse(): Record<string, any> | null {
    if (!this.filters) return null;
    try { return JSON.parse(this.filters); } catch { return null; }
  }

  private buildFilters(parsed: Record<string, any>, policies: { guid: string; displayName: string }[]) {
    const guidToName = new Map(policies.map(p => [p.guid?.toLowerCase(), p.displayName]));

    this.parsedFilters = Object.entries(parsed)
      .filter(([key, value]) =>
        !this.excludedKeys.includes(key) &&
        value !== undefined && value !== null && value !== ''
      )
      .map(([key, value]) => {
        const raw = Array.isArray(value) ? (value as string[]).join(',') : String(value);
        let parts = raw.split(',').map(v => v.trim()).filter(v => v !== '');

        if (key === 'policy' && guidToName.size > 0) {
          parts = parts.map(v => guidToName.get(v.toLowerCase()) ?? v);
        }

        return { labelKey: this.keyLabels[key] || key, values: parts };
      });
  }
}
